import { QueryDispatcher } from "../../shared/domain/QueryDispatcher";

export class BankAccountTransactions {
  constructor(
    private readonly dispatcher: QueryDispatcher,
    private readonly frontend,
  ) { }

  async run_filter(uuid:String|Number, listFilters:any, simpleFilter:any, limit:number, offset:number): Promise<any> {
    if (uuid != null) {
      let args = { 
        uuid: uuid,
        filters: {},
        limit:limit,
        offset:offset
      }
      Object.keys(listFilters).forEach((element) => {
        if (listFilters[element] && listFilters[element].value) {
          args['filters'][element] = listFilters[element].value;
        }
      })
      if (simpleFilter && simpleFilter['code'] == 'default_counterpart') {
        args['filters']['default_contrapartida'] = 'no'
      }
      else if (simpleFilter && simpleFilter['code'] == 'contains_effects') {
        args['filters']['contains_effects'] = 'yes'
      }
      else if (simpleFilter && simpleFilter['code'] == 'none') {
        args['filters']['default_contrapartida'] = 'yes'
        args['filters']['contains_effects'] = 'no'
      }
      
      let data = undefined;
      this.frontend.change_loading_get_transactions(uuid, true)
      data = await this.dispatcher.dispatch('bank_account_transactions.data', args) 
      this.frontend.change_loading_get_transactions(uuid, false)
      if (data.status === '200') {
        this.frontend.transactions_list = data.data
        this.frontend.totalTransactions = data.count
        this.frontend.totalAmountTransactions = data.total_amount
        this.frontend.hasProviderTransactions = data.has_provider_transactions
        if (data.count > 0){
          this.frontend.showSelectTransactions = true
        }
        this.frontend.selectedTransactions = []
        this.frontend.calculateTableHeight()
      } else {
        this.frontend.transactions_list = []
        this.frontend.totalTransactions = 0
        this.frontend.totalAmountTransactions = 0
        if (data.status === '404' && data.hasOwnProperty('has_provider_transactions')) {
          this.frontend.hasProviderTransactions = data.has_provider_transactions
        } else {
          this.frontend.hasProviderTransactions = false
        }
        this.frontend.selectedTransactions = []
        this.frontend.calculateTableHeight()
        return 'There is no data for this company id'
      }
    }
  }
}